import React from 'react';
import { useTranslation } from 'react-i18next';

const SkipVideo = () => {

  const { t } = useTranslation();

  return (
    <div role='button' tabIndex={0} id="skip-video" className="skip">
      <span className="current-time" id="sec" />
      {t('intro.skip_video')}
    </div>
  );
};

export default SkipVideo;
